import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function CheckIcon({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 50 52'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M25.4658 0.971436C39.2756 0.971436 50.4658 12.1616 50.4658 25.9714C50.4658 39.7813 39.2756 50.9714 25.4658 50.9714C11.656 50.9714 0.46582 39.7813 0.46582 25.9714C0.46582 12.1616 11.656 0.971436 25.4658 0.971436ZM25.4658 4.09644C13.3819 4.09644 3.59082 13.8875 3.59082 25.9714C3.59082 38.0554 13.3819 47.8464 25.4658 47.8464C37.5498 47.8464 47.3408 38.0554 47.3408 25.9714C47.3408 13.8875 37.5498 4.09644 25.4658 4.09644ZM15.9885 24.8682C16.5986 24.2578 17.5879 24.2576 18.1983 24.8677L23.7143 30.3811L34.3335 18.2469C34.9018 17.5975 35.8889 17.5318 36.5383 18.1001C37.1877 18.6684 37.2534 19.6555 36.6851 20.3049L24.9663 33.6955C24.3712 34.3756 23.3251 34.4105 22.6859 33.7716L15.9891 27.0779C15.3787 26.4678 15.3785 25.4785 15.9885 24.8682Z'
      />
    </svg>
  );
}
